











import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component
export default class LeftRight extends Vue {
    @Prop({ default: false }) disableLeft: boolean;
    @Prop({ default: false }) disableRight: boolean;

    @Emit()
    left() {}

    @Emit()
    right() {}
}
